import * as types from './mutation-types'
import {SET_TABLE_ORDERS, SET_TABLES_STATUS} from "./mutation-types";

export default {
    [types.ADD_TABLE] (state, data) {
        state.tablesLoaded = true
        state.tables.push(data)
    },

    [types.ADD_TABLES] (state, data) {
        state.tablesLoaded = true
        state.tables = data
    },

    [types.LOAD_TABLE]: (state, data) => {
        let tableExist = state.tables.find(x => x.id === data.id)
        if(tableExist){
            state.tables = state.tables.map((x) => {
                if(x.id === data.id){
                    return data
                }

                return x
            })
        }else{
            state.tables.push(data)
        }
    },

    [types.LOAD_TABLES]: (state, data) => {
        state.tablesLoaded = true
        state.tables = data
    },

    [types.DELETE_TABLE_PERIMETER]: function(state, id){
        state.tables = state.tables.map((tab) => {
            if(tab.id === id){
                tab.perimeter_id = null
            }
            return tab
        })
    },

    [types.SET_TABLE_ORDERS]: function(state, order){
        let tables = order.tables
        console.log(tables)
        let tableMerged = []
        tables.forEach(table => {
            if(table.table){
                tableMerged.push(table)
            }
        })
        console.log(tableMerged)

        state.tables = state.tables.map((tab) => {
            let table = tables.find(item => item.id === tab.id )

            if(table){
                tab.status = table.status
                tab.orders?.push(order)
            }

            table = tableMerged.find(item => item.id === tab.id )

            if(table){
                tab.status = table.status
                tab.orders?.push(order)
            }
            return tab
        })
    },

    [types.SET_ORDERS_TABLE_STATUS] (state, tables) {
        state.tables = state.tables.map(table => {
            let tableMap = tables.find(tab => tab.id === table.id)

            if(tableMap){
                table.status = tableMap.status
            }

            return table
        })
    },
    [types.SET_TABLES_STATUS] (state, tables) {
        state.tables = state.tables.map(table => {
            let tableMap = tables.find(tab => tab.id === table.id)

            if(tableMap){
                table.status = tableMap.status
            }

            return table
        })
    }


}


